<!-- Divider -->
<div
  class="ui-vertical-navigation-item-wrapper divider"
  [ngClass]="item.classes?.wrapper"
></div>
